import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpStatusCode } from "@angular/common/http";
import { Observable, catchError, throwError } from "rxjs";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { LoggedInUserKeys, LoggedInUserService } from "../service/logged-in-user.service";

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    private readonly router: Router,
    private readonly _toastrService: ToastrService,
    private readonly loggedInUserService: LoggedInUserService
  ) { }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const skipErrorHandling = request.headers.has('X-Skip-Error-Interceptor');

    if (!navigator.onLine) {
      // this._toastrService.warning("You are offline. Waiting for network...");
      return new Observable<HttpEvent<unknown>>((observer) => {
        const handleOnline = () => {
          window.removeEventListener("online", handleOnline);
          // this._toastrService.success("Network restored. Resuming request...");
          next.handle(request).subscribe(observer);
        };
        window.addEventListener("online", handleOnline);
      });
    }

    return next.handle(request).pipe(
      catchError((error: ErrorRoot) => {
        const loggedInUserStringValue = this.loggedInUserService.getLoggedInUser(
          LoggedInUserKeys.LOGGED_IN_USER
        );
        const isUnauthorized =
          error?.status === HttpStatusCode.Unauthorized ||
          error?.error?.statusCode === HttpStatusCode.Unauthorized ||
          Number(error?.error?.status) === HttpStatusCode.Unauthorized;
        const errorMessage = error?.error?.message || error?.message || "Unauthorized";

        if (error) {
          if (isUnauthorized) {
            if (
              loggedInUserStringValue?.userRole == "FRACTAL_HR" ||
              loggedInUserStringValue?.userRole == "FRACTAL_ADMIN" || 
              loggedInUserStringValue?.userRole == "PROJECT_MANAGER" ||
              loggedInUserStringValue?.userRole == "VISITOR"
            ) {
              this.router.navigate(["/admin/sign-in"]);
            } else {
              this.router.navigate(["/sign-in"]);
            }
            if (!skipErrorHandling) {
              this._toastrService.error(errorMessage, "Error");
            }
            setTimeout(() => { 
              localStorage.clear();
              sessionStorage.clear();
            }, 1000);
          } else if (error.error?.statusCode === HttpStatusCode.BadRequest) {
            if (!skipErrorHandling) {
              this._toastrService.error(error.error.message, "Error");
            }
          } 
          // else if (error.error?.statusCode === HttpStatusCode.BadGateway) {
          //     if (loggedInUserStringValue?.userRole == "FRACTAL_HR" || loggedInUserStringValue?.userRole == "FRACTAL_ADMIN" || 
          //       loggedInUserStringValue?.userRole == "PROJECT_MANAGER" || loggedInUserStringValue?.userRole == "VISITOR") {
          //         this.router.navigate(["/admin/sign-in"]);
          //       } else {
          //         this.router.navigate(["/"]);
          //     }
          //     this._toastrService.error(
          //       'We’re having trouble connecting to the server. Please try again in a few moments.'
          //     );
          //     setTimeout(() => { 
          //        localStorage.clear();
          //        sessionStorage.clear();
          //      }, 1000);
          // } 
          // else if (error.error?.statusCode === HttpStatusCode.GatewayTimeout) {
          //     if (loggedInUserStringValue?.userRole == "FRACTAL_HR" || loggedInUserStringValue?.userRole == "FRACTAL_ADMIN" || 
          //         loggedInUserStringValue?.userRole == "PROJECT_MANAGER" || loggedInUserStringValue?.userRole == "VISITOR") {
          //           this.router.navigate(["/admin/sign-in"]);
          //         } else {
          //           this.router.navigate(["/"]);
          //     }
          //     this._toastrService.error(
          //       'The request is taking longer than expected. Please try again.'
          //     );
          //     setTimeout(() => { 
          //         localStorage.clear();
          //         sessionStorage.clear();
          //       }, 1000);
          // }
          else if (!navigator.onLine) {

            // this._toastrService.warning("Network lost. Retrying when connected...");
            return new Observable<HttpEvent<unknown>>((observer) => {
              const handleOnline = () => {
                window.removeEventListener("online", handleOnline);
                // this._toastrService.success("Network restored. Retrying request...");
                next.handle(request).subscribe(observer);
              };
              window.addEventListener("online", handleOnline);
            });
          }
        }

        return throwError(() => error);
      })
    );
  }
}

export interface ErrorRoot {
  headers: Headers;
  status: number;
  statusCode: number;
  statusText: string;
  url: string;
  ok: boolean;
  name: string;
  message: string;
  error: Error;
}

export interface Headers {
  normalizedNames: NormalizedNames;
  lazyUpdate;
}

export interface NormalizedNames {}

export interface Error {
  status: string;
  message: string;
  data;
  statusCode: number;
  value;
  msg;
  objectData;
}
